import { client } from '@/api/orpc'
import { sleep } from '@/utils/sleep'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLive = defineStore('live', () => {
	const last = ref<
		{
			modelUuid: string
			time: number
			preloader: string | null
			modelName: string
			price: number
			caseUuid: string
		}[]
	>([])

	const startIterating = async () => {
		const { error, data } = await client.game.subCaseOpenings(
			{}
			// {
			// 	context: {
			// 		retry: Number.POSITIVE_INFINITY
			// 	}
			// }
		)

		if (error) {
			console.error(error)
			return
		}
		if (!data) {
			return
		}

		try {
			for await (const event of data) {
				last.value.unshift({ ...event, time: Date.now() })

				if (last.value.length > 10) {
					last.value.splice(10, 1)
				}

				await sleep(1)
			}
		} catch (error) {
			console.error('ERROR IN LIVE', error)
		}
	}

	startIterating()

	return {
		last
	}
})
